import { combineReducers } from 'redux';
import { WPReducer } from '../utils/wp';
import UIReducer from '../components/Root/ui-reducer';
import menuReducer from '../components/Header/menu-reducer';

const rootReducer = combineReducers({
	UI: UIReducer,
	menu: menuReducer,
	galleries: WPReducer('galleries'),
	posts: WPReducer('posts'),
	videos: WPReducer('videos'),
	categories: WPReducer('categories'),
	albums: WPReducer('albums'),
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/store/root-reducer.js